import { render, staticRenderFns } from "./ViewerConfiguration.vue?vue&type=template&id=ec759d70&"
import script from "./ViewerConfiguration.vue?vue&type=script&lang=ts&"
export * from "./ViewerConfiguration.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports